/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Pdf_Or_Web_UrlInputs */

const en_mobile_pdf_or_web_url = /** @type {(inputs: Mobile_Pdf_Or_Web_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF or Web Page URL`)
};

const es_mobile_pdf_or_web_url = /** @type {(inputs: Mobile_Pdf_Or_Web_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de PDF o página web`)
};

/**
* | output |
* | --- |
* | "PDF or Web Page URL" |
*
* @param {Mobile_Pdf_Or_Web_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_pdf_or_web_url = /** @type {((inputs?: Mobile_Pdf_Or_Web_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Pdf_Or_Web_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_pdf_or_web_url(inputs)
	return en_mobile_pdf_or_web_url(inputs)
});